export const formatName = (name: string): string =>
    name ? name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) : "";